import React from "react";

import BipononGrayIcon from "../icons/biponon-gray.svg";
// import MapIcon from "../icons/map-region.svg";
import SearchImage from "../images/Search.png";
import { isNumber } from "../../../utilities/helpers";

const LoanHistoryCard = ({
  loans_taken,
  unrecovered_count,
  recovered_count,
  ongoing_loan_count,
  late_payment_percentage,
  // pre_approved_amount,
  loading = false,
  error = false,
  errorMessage = "",
}) => {
  const loanHistory = [
    {
      label: "Loans Taken Count",
      value: isNumber(loans_taken) ? Number(loans_taken) : "N/A",
      icon: BipononGrayIcon,
    },
    {
      label: "Unrecovered Loans Count",
      value: isNumber(unrecovered_count) ? Number(unrecovered_count) : "N/A",
      icon: BipononGrayIcon,
    },
    {
      label: "Recovered Loans Count",
      value: isNumber(recovered_count) ? Number(recovered_count) : "N/A",
      icon: BipononGrayIcon,
    },
    {
      label: "Ongoing Loans Count",
      value: isNumber(ongoing_loan_count) ? Number(ongoing_loan_count) : "N/A",
      icon: BipononGrayIcon,
    },
    {
      label: "Late Payment Percentage",
      value: late_payment_percentage || "N/A",
      icon: BipononGrayIcon,
    },
    // {
    //   label: "Pre Approved Amount",
    //   value: isNumber(pre_approved_amount)
    //     ? Number(pre_approved_amount)
    //     : "N/A",
    //   icon: MapIcon
    // }
  ];

  if (loading) {
    return (
      <div className="card-section" style={{ flex: 1 }}>
        <h3 className="card-section__title">Loan History</h3>
        <div className="details-item-container">
          {[...Array(6)].map((_, index) => (
            <div className="icon-details-item" key={index}>
              <div className="skeleton skeleton-icon"></div>
              <div className="icon-details-text">
                <div className="skeleton skeleton-text skeleton-text--small"></div>
                <div className="skeleton skeleton-text skeleton-text--medium"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="card-section" style={{ flex: 1 }}>
        <h3 className="card-section__title">Loan History</h3>
        <div className="error-state">
          <img src={SearchImage} alt="Error" className="error-image" />
          <h4 className="error-title">Error Fetching Data</h4>
          <p className="error-message">{errorMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="card-section"
      style={{
        flex: 1,
      }}
    >
      <h3 className="card-section__title">Loan History</h3>
      <div className="details-item-container">
        {loanHistory.map((item, index) => (
          <div className="icon-details-item" key={index}>
            <img
              src={item.icon}
              alt={`${item.label} icon`}
              className="details-icon"
            />
            <div className="icon-details-text">
              <span className="label">{item.label}</span>
              <span className="value">{item.value}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoanHistoryCard;
